export const defaultYearObject = {
    year: null,
    carrier: null,
    policyNumber: null,
    claims: null,
    claimsPaid: null
};

export default [...Array(5).fill(defaultYearObject)];
  